import * as type from '../mutation-types';
import { createActionHelpers } from 'vuex-loading';
import m from 'moment';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const getters = {
    tax: state => {
        return state.tax;
    },

    taxList: state => {
        return state.taxList;
    },

    taxAutoAssignProductList: state => {
        return state.taxList.filter(t => t.auto_assign_product == 1);
    },
};

const state = {
    tax: {
        id: null,
        name: null,
        short_name: null,
        amount: null,
        mode: 0,
        inclusive: false,
        tax_before_discount: false,
        auto_assign_outlet: false,
        auto_assign_product: false,
        products: [],
        fuels: [],
        tags: [],
        amount_type: false,
        effective_at: m().startOf('day'),
        item_type: null,
    },
    taxList: [],
};

const mutations = {
    [type.SET_TAX_LIST](state, taxList) {
        state.taxList = taxList;
    },

    [type.SET_TAX](state, tax) {
        state.tax = tax;
    },

    [type.SET_TAX_ATTRIBUTE](state, { key, value }) {
        state.tax[key] = value;
    },
};

const actions = {
    getTax({ commit }, id) {
        let route = Laroute.route('franchise.inventory.tax.show', { id });

        return axios
            .get(route)
            .then(res => {
                commit(type.SET_TAX, res.data.data);
                return res.data.data;
            })
            .catch(err => {
                throw err;
            });
    },

    async getTaxList({ commit, dispatch }) {
        let api = Laroute.route('franchise.vue.gettaxselect');
        startLoading(dispatch, 'fetch-tax');

        try {
            const { data } = await axios.get(api);
            commit(type.SET_TAX_LIST, data.data);
            endLoading(dispatch, 'fetch-tax');
        } catch (e) {
            endLoading(dispatch, 'fetch-tax');
            throw e;
        }
    },

    createTax({ state }, payload = {}) {
        const route = Laroute.route('franchise.inventory.tax.store');
        const products = state.tax.products.map(p => p.id);
        const outlets = state.tax.outlets.map(p => p.id);
        const tags = state.tax.tags.map(p => p.id);
        const fuels = state.tax.fuels.map(p => p.id);

        if (state.tax.effective_at) {
            state.tax.effective_at = moment(state.tax.effective_at).format(
                'YYYY-MM-DD',
            );
        }

        if (state.tax.deactivate_at) {
            state.tax.deactivate_at = moment(state.tax.deactivate_at).format(
                'YYYY-MM-DD',
            );
        }

        const params = _.merge(state.tax, {
            products,
            outlets,
            tags,
            fuels,
            filters: payload.filters,
        });

        return axios.post(route, params);
    },

    updateTax({ state }, payload = {}) {
        const route = Laroute.route('franchise.inventory.tax.update', {
            id: state.tax.id,
        });
        const products = state.tax.products.map(p => p.id);
        const outlets = state.tax.outlets.map(p => p.id);
        const tags = state.tax.tags.map(p => p.id);
        const fuels = state.tax.fuels.map(p => p.id);

        if (state.tax.effective_at) {
            state.tax.effective_at = moment(state.tax.effective_at).format(
                'YYYY-MM-DD',
            );
        }

        if (state.tax.deactivate_at) {
            state.tax.deactivate_at = moment(state.tax.deactivate_at).format(
                'YYYY-MM-DD',
            );
        }

        const params = _.merge(state.tax, {
            products,
            outlets,
            tags,
            fuels,
            filters: payload.filters,
            outletFilters: payload.outletFilters,
        });

        return axios.patch(route, params);
    },

    setTaxAttribute({ commit }, payload) {
        commit(type.SET_TAX_ATTRIBUTE, payload);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
